import "lazysizes";
import "lazysizes/plugins/unveilhooks/ls.unveilhooks";

function initClickForHref() {
  document.querySelectorAll(".jsClickForHref").forEach((el) => {
    el.addEventListener("click", () => {
      const href = el.getAttribute("data-href");
      if (href) {
        window.location.href = href;
      }
    });
  });
}

document.addEventListener("DOMContentLoaded", initClickForHref);
